import React from 'react';
import { useRecoilValue } from 'recoil';
import { themeModeAtom, themeModeEnum } from 'src/recoil/atoms/themeModeAtom';
import { LabelledOutline } from '../../../common/final-form-material-ui';

interface ISubcontainer {
  className?: string;
  children: React.ReactNode;
  title?: string;
  show?: boolean;
  minHeight?: number;
  labelLeft?: number;
}
/**
 * Modal for wizard interface
 */
export function Subcontainer({
  className,
  title,
  show,
  children,
  minHeight,
  labelLeft,
}: ISubcontainer) {
  const themeMode = useRecoilValue(themeModeAtom);
  return show ? (
    <LabelledOutline
      label={title ?? ''}
      className={className}
      minHeight={minHeight}
      labelLeft={labelLeft}
      backgroundColor={
        themeMode === themeModeEnum.DARK_MODE ? '#121c21' : '#fff'
      }
    >
      {children}
    </LabelledOutline>
  ) : null;
}
